import React, { useEffect, useRef, useState } from 'react';


import Advogado from'../../../acets/adv.jpg'
import { useFont } from '../../../ContextFont';
import IcoEdit from'../../../acets/icon/edit.svg'

export default function Lay01(props) {
  const { imagens, handleDownloadImage } = useFont();
  const divRef = useRef(null);

  const [titulo, setTitulo]=useState(props.datal.titulo)
  const [subtitulo,setSubtitulo]=useState(props.datal.subtitulo)
  const [modalData, setModaldata]=useState(false)
  const [numimg,setNumimg]=useState(0)
  const [cor, setCor] = useState(`${props.trapColor}${props.inclinacao}`);

  useEffect(() => {
    // Atualiza os estados locais quando props.datal é alterado
    setTitulo(props.datal.titulo);
    setSubtitulo(props.datal.subtitulo);
    setCor(`${props.trapColor}${props.inclinacao}`);
  }, [props.datal,props.trapColor, props.inclinacao]); 
 
  return (
  
    <div className='w33 cell-tamanho90 center celular b2 cont-circ7 bordaElements ma10b0'>

      <div className='p10 b2 w5 cont-circ50pc fb'>1</div>
      
      <div  className="w100 h40 column between" >
        <div ref={divRef} id="resultImg01"  className="w100 z15 h33" >
            <div className="w100 z15 h40 row" style={{ backgroundImage: `url(${imagens.length > 0 ? imagens[numimg].urls.small : Advogado})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
            
            <div className="w50 h40 column center" style={{ width: `${props.boxtitlesize}px`, background: cor }}>
                <label className='c3 fb w90 ma5' style={{ fontSize: `${props.titlesize}px`, color: props.textColor }}>{titulo}</label>
                <label className='p20 fw500 z4 w90 b-vidro cont-circ7 mac0l8' style={{ fontSize: `${props.subtitlesize}px`, color: props.subtextColor }}>{subtitulo}</label>
                {props.datav.preco&&<div className='row p7'>
                <label className='fb'style={{fontSize:`${props.subtitlesize*0.95}px`,color:props.subtextColor}}>R$:</label>
                <label className='fb' style={{fontSize:`${props.subtitlesize*1.95}px`,color:props.subtextColor}}>{props.datav.preco}</label> 
                </div>}
              </div>
              <div className='h33 z15 '  style={{ width: `${100-props.boxtitlesize}px`}}>
              
              </div>
          { modalData&&
            <div className='posiabste b2 h30 z16 w17 p10 cell-tamanho-metade55 bordaElements'>
             
              <div className='w100 row between'>
                 <label className=''>Titulo</label>
                <img src='https://cdn-icons-png.flaticon.com/128/70/70287.png' className='pp w10' onClick={() => setModaldata(!modalData)}/>
              </div>
              <input type='text' value={titulo} onChange={(e)=>setTitulo(e.target.value)}/>
              <label>Subtitulo</label>
              <input type='text' value={subtitulo} onChange={(e)=>setSubtitulo(e.target.value)}/>
            </div>
            }
            </div>
           
           
          </div>
        </div>

      <div className="w100 he20 overflowY">
          <div className="w100 row between ma5">
            <div className="row w50">
              <img src='https://cdn-icons-png.flaticon.com/128/535/535285.png' className='w15 ml5' alt='plus / mais' />
              <img src='https://cdn-icons-png.flaticon.com/128/5948/5948565.png' className='w15 ml5' alt='plus / mais' />
              <img src='https://cdn-icons-png.flaticon.com/128/5728/5728145.png' className='w15 ml5' alt='plus / mais' />
            </div>
            <div className="w50 row between">
              
            </div>
          </div>
          <label className="fs08em">{props.datal.legenda}</label>
          <div>
            <label className="w100 fs08em fw500">{props.datal.hashtag}</label>
          </div>
      </div>


      <div className='w100 row between'> 
        <div className='h5 w30 fs08em cont-circ8 pp b2 row center  m10 c4' 
            onClick={() => setNumimg(numimg >= 9 ? 0 : numimg + 1)}>
              Imagem
              <img src='https://cdn-icons-png.flaticon.com/128/1829/1829415.png' alt='IcoEdit' className='w17 m10'/>
            </div>
        <div 
            className='w30 h5 fs08em cont-circ8 pp b2 row center  m10 c4'
            onClick={() => setModaldata(!modalData)}>
            {modalData ? "Fech." : "Texto"}
            <img src={IcoEdit} alt='IcoEdit' className='w25'/>
        </div>
        <div 
          className="w30 h5 fs08em cont-circ8 pp b2 row center  m10 c4" 
          onClick={() => handleDownloadImage('resultImg01')}>
            Baixar
          <img src='https://cdn-icons-png.flaticon.com/128/5191/5191992.png' alt='IcoEdit' className='w17 m10'/>
        </div>
      </div> 
    
    
    </div>
  )




  /*
 b2 cont-circ7 bordaElements ma10b0
  
  <div className='p10 b2 w10 cont-circ50pc fb'>11</div>

          { modalData&&
            <div className='posiabste b2 h30 z16 w17 p10 cell-tamanho-metade55 bordaElements'>
              <div className='w100 row between'>
                 <label className=''>Titulo</label>
                <img src='https://cdn-icons-png.flaticon.com/128/70/70287.png' className='pp w10' onClick={() => setModaldata(!modalData)}/>
              </div>
              <input type='text' value={titulo} onChange={(e)=>setTitulo(e.target.value)}/>
              <label>Subtitulo</label>
              <input type='text' value={subtitulo} onChange={(e)=>setSubtitulo(e.target.value)}/>
            </div>
            }


      <div className='w100 row between'> 
        <div className='h5 w30 fs08em cont-circ8 pp b2 row center  m10' 
            onClick={() => setNumimg(numimg >= 9 ? 0 : numimg + 1)}>
              Imagem
              <img src='https://cdn-icons-png.flaticon.com/128/1829/1829415.png' alt='IcoEdit' className='w17 m10'/>
            </div>
        <div 
            className='w30 h5 fs08em cont-circ8 pp b2 row center  m10'
            onClick={() => setModaldata(!modalData)}>
            {modalData ? "Fech." : "Texto"}
            <img src={IcoEdit} alt='IcoEdit' className='w25'/>
        </div>
        <div 
          className="w30 h5 fs08em cont-circ8 pp b2 row center  m10" 
          onClick={() => handleDownloadImage('resultImg01')}>
            Baixar
          <img src='https://cdn-icons-png.flaticon.com/128/5191/5191992.png' alt='IcoEdit' className='w17 m10'/>
        </div>
      </div> 















  <div className='w33 b7'>
      <div ref={divRef} className="w100 h33 column between cell-tamanho" >

        <div  className="w18 b7 h33 posiabste cell-tamanho-metade55" style={{ backgroundImage: `url('${props.backgroundImage}')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
          <div className='w100 h33 posiabste fundo-opaco-light'>
          </div>
        </div>
        <div className="w100 z16">
          <div className="posiabste h33 w18 column center"  >
          </div>
          <div className="posiabste h33 w8 column center">

            <div className="p7 column" style={{ width: `${props.boxtitlesize}px` }}>
              <label className='c3 fb ' style={{ fontSize: `${props.titlesize}px`, color: props.textColor }}>{props.datal.titulo}</label>
              <label className='c3 fw500 p7 ' style={{ fontSize: `${props.subtitlesize}px`, color: props.subtextColor }}>{props.datal.subtitulo}</label>
            </div>
          </div>
          <div
            className="w100"
            style={{
              width: 0,
              height: 0,
              borderLeft: `${140 - 0.99 * props.inclinacao}px solid ${props.trapColor}`,// TAMANHO  80
              borderRight: `${props.inclinacao}px solid transparent`, // INCLINAÇÃO 100
              borderBottom: `33vh solid ${props.trapColor}`,
              marginTop: '0px',
            }}
          ></div>
        </div>
      </div>

      <div className="w100 he40 overflowY">
          <div className="w100 row between ma5">
            <div className="row w50">
              <img src='https://cdn-icons-png.flaticon.com/128/535/535285.png' className='w15 ml5' alt='plus / mais' />
              <img src='https://cdn-icons-png.flaticon.com/128/5948/5948565.png' className='w15 ml5' alt='plus / mais' />
              <img src='https://cdn-icons-png.flaticon.com/128/5728/5728145.png' className='w15 ml5' alt='plus / mais' />
            </div>
            <div className="w50 row end">
              <img src='https://cdn-icons-png.flaticon.com/128/5662/5662990.png' className='w15 ml5' alt='plus / mais' />
            </div>
          </div>
          <label className="fs08em">{props.datal.legenda}</label>
          <div>
            <label className="w100 fs08em fw500">{props.datal.hashtag}</label>
          </div>
      </div>

      <button className="w100 ma5 p20 fs08em " onClick={handleConvertToImage}>
        Export
      </button>

      <div id="resultImgy" className="b1 w100 center column"></div>
    </div>



  
















     const divRef = useRef(null);
  const handleConvertToImage = () => { //CHAT GPT QUE CRIOU
    htmlToImage.toPng(divRef.current)
      .then(function (dataUrl) {
        const img = new Image();
        img.src = dataUrl;
        document.getElementById("resultImg01").appendChild(img);
      })
      .catch(function (error) {
        console.error('Oops, something went wrong!', error);
      });
  };
  
  
  */



}

